import {Component, Prop} from 'vue-property-decorator';
import * as tsx from 'vue-tsx-support';

import './style.less';

interface IRename {
  placeholder?: string;
  value?: string;
  change?: any;
}

@Component
export default class Rename extends tsx.Component<IRename> {
  
  @Prop() public placeholder?: string;
  @Prop() public value?: string;
  @Prop() public change?: any;
  
  render() {
    const {value, change} = this.$props;
    return (
      <div class='rename-container'>
        <div class='title'>
          修改当前云手机名称
        </div>
        <div class="input-container">
          <input onInput={(e) => change(e)} value={this.$props.value} class='input' type="text" placeholder='请输入要修改的云手机名称'/>
          <div class="text">{`${this.$props.value.length}/20` }</div>
        </div>
      </div>
    )
  }
  
}